import { connect } from 'react-redux';
import { IStateType } from '../../../store/models/root.interface';
import { setDataLayerInfo } from '../../../store/actions/miscellaneous.action';
import BalanceButton, {
	MapStatePropsType,
	DispatchPropsType,
} from '../molecules/BalanceButton';

const mapStateToProps = (state: IStateType) => ({
	isPostpaid: state.balance.isPostpaid,
	baseCurrencyVal: state.balance.baseCurrencyVal,
	maxPostpaidLimit: state.balance.maxPostpaidLimit,
	baseCurrencySymbol: state.balance.baseCurrencySymbol,
});

const mapDispatchToProps = {
	setDataLayerInfo: () => setDataLayerInfo(),
};

export default connect<MapStatePropsType, DispatchPropsType, unknown, IStateType>(
	mapStateToProps,
	mapDispatchToProps
)(BalanceButton);
